module.exports = __webpack_public_path__ + "static/media/icons8-bulleted-list.69dad8b5.svg";